import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { DataWpServicePlanes } from '../../data-wp.service';
import { PostI } from '../../post.interface';

@Component({
  selector: 'app-secciones-destacadas',
  templateUrl: './secciones-destacadas.component.html',
  styleUrls: ['./secciones-destacadas.component.css'],
  providers: [DataWpServicePlanes]
})
export class SeccionesDestacadasComponent implements OnInit {

  constructor(
    private dataWp: DataWpServicePlanes, 
    private sanitizer: DomSanitizer
    ) { 

    }
  
  posts$: Observable<PostI[]>;
  
  transform(html) {
      return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  ngOnInit() {
    this.posts$ = this.dataWp.getPosts();
  }  

}
